import type { StoreCityGroupVm, PhysicalStoreVm } from '../viewModels/physicalStore.vm';
import { StoreListItem } from './StoreListItem';

type StoreListMobileProps = {
  cityGroups: StoreCityGroupVm[];
  onStoreSelect: (store: PhysicalStoreVm) => void;
};

export function StoreListMobile({ cityGroups, onStoreSelect }: StoreListMobileProps) {
  if (cityGroups.length === 0) {
    return (
      <p className="px-4 py-8 text-center text-sm text-gray-500">No stores found.</p>
    );
  }

  return (
    <div className="space-y-6 px-4 pb-8">
      {cityGroups.map((group) => (
        <div key={group.cityName}>
          <h2 className="mb-3 text-sm font-bold uppercase tracking-wide text-gray-900">
            {group.cityName}
          </h2>
          <div className="space-y-2">
            {group.stores.map((store) => (
              <StoreListItem
                key={store.sid || store.id}
                store={store}
                onSelect={onStoreSelect}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
